import { BrowserRouter, Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "./css/App.css";
import "./css/queries.css";
import Homepage from "./pages/Homepage";
import Biography from "./pages/Biography";
import Projects from "./pages/Projects";
import Footer from "./pages/Footer";
import Tours from "./pages/Tours";

import Header from "./components/Header";
import AdminProtectedRoute from "./pages/AdminProtectedRoute";
import AdminPage from "./pages/AdminPage";
import LogInPage from "./pages/LoginPage";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // staleTime: 60 * 1000,
            staleTime: 0,
        },
    },
});

function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <Routes>
                    <Route
                        index
                        element={
                            <main>
                                <Header />
                                <Homepage />
                                <Projects />
                                <Biography />
                                <Tours />
                                <Footer />
                            </main>
                        }
                    />
                    <Route
                        path="admin"
                        element={<LogInPage />}
                    />
                    <Route
                        path="admin/projects"
                        element={
                            <AdminProtectedRoute>
                                <AdminPage />
                            </AdminProtectedRoute>
                        }
                    />
                </Routes>
            </BrowserRouter>
        </QueryClientProvider>
    );
}

export default App;
